/**
 * Global Product Card Swiper Handler
 * Initializes Swiper sliders on cards lazily after DOM load.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-swiper-card]').forEach(function (el) {
    if (!el.id) return;

    // Initialize Swiper Instance
    const swiper = new Swiper('#' + el.id, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 300,
      autoplay: false,
      loop: true,
      allowTouchMove: false
    });

    // Find the enclosing card wrapper boundary
    const cardWrapper = el.closest('.card-wrapper');
    if (cardWrapper) {
      cardWrapper.addEventListener('mouseenter', function () {
        swiper.slideToLoop(1);
      });
      cardWrapper.addEventListener('mouseleave', function () {
        swiper.slideToLoop(0);
      });
    }
  });
});